export const translations = {
  en: {
    startQuiz: "Begin Quiz",
    nextQuestion: "Next Question",
    nextSection: "Next Section",
    seeResults: "See Results",
    previous: "Previous",
    quizTitle: "Career Orientation Quiz",
    quizDescription:
      "This quiz will help you discover potential career paths based on your preferences and learning style.",
    selectedProfessions: "Selected Professions",
    currentPairs: "Current Pairs",
    resultsTitle: "Quiz Results",
    totalQuestions: "Total questions answered",
    totalPoints: "Total points accumulated",
    takeQuizAgain: "Take Quiz Again",
    interestTitle: "Your Interest",
    interestDescription: `"Interests" describe the types of activities that you are drawn to; these will need to be present in a job or career that you are considering if you are to stay motivated.`,
    avoidFields: "Avoid any related field of interest",
    section: "Section",
    question: "Question",
    of: "of",
    avoid: "Avoid any related field of interest",
    based: "Based on your answers, you might be suited for a career in ",
    totalskor: "Total Score: ",
    detaljno: "Detailed Scores: ",
    interes: "Interest Type",
    zuti: "Detail-oriented - systematic, predictable",
    interests: {
      RED: {
        description: "Problem Solver - practical, technical, hands-on",
        title: "RED Interest",
      },
      BLUE: {
        description: "Creative/Humanitarian - creative, thoughtful, quiet",
        title: "BLUE Interest",
      },
      YELLOW: {
        description: "Detail-oriented - systematic, predictable",
        title: "YELLOW Interest",
      },
      GREEN: {
        description: "Influencer - persuasive, people-oriented",
        title: "GREEN Interest",
      },
    },
    saving: "Saving",
    tryAgain: "Try again",
    viewRankings: "View Rankings",
    rankingsTitle: "Top Quiz Results",
    loading: "Loading...",
    error: "Error loading data",
    noScoresError: "No scores were calculated. Please try again.",
    userInfoMissing: "User information is missing",
    saveError: "Failed to save results. Please try again.",
    saveStage: "Save Progress",
    stageSaved: "Progress saved!",
    continueQuiz: "Continue Quiz",
    savedProgress: "You have saved progress",
    savedProgressSection: "Section",
    savedProgressQuestion: "Question",
    deleteSavedProgress: "Delete Saved Progress",
    // Add more translations as needed
  },
  bg: {
    startQuiz: "Започнете теста",
    nextQuestion: "Следващ въпрос",
    nextSection: "Следващ раздел",
    seeResults: "Вижте резултатите",
    previous: "Предишен",
    quizTitle: "Тест за кариерна ориентация",
    quizDescription:
      "Този тест ще ви помогне да откриете потенциални кариерни пътеки въз основа на вашите предпочитания и стил на учене.",
    selectedProfessions: "Избрани професии",
    currentPairs: "Текущи двойки",
    resultsTitle: "Резултати от теста",
    totalQuestions: "Общо отговорени въпроси",
    totalPoints: "Общо натрупани точки",
    takeQuizAgain: "Направете теста отново",
    interestTitle: "Вашите интереси",
    interestDescription: `"Интересите" описват видовете дейности, към които сте привлечени; те трябва да присъстват в работата или кариерата, която обмисляте, за да останете мотивирани.`,
    avoidFields: "Избягвайте свързаните области на интерес",
    section: "Раздел",
    question: "Въпрос",
    of: "от",
    avoid: "Избягвайте всякакви свързани области на интереси",
    based: "Въз основа на отговорите ви може да сте подходящи за кариера в ",
    totalskor: "Общ резултат: ",
    detaljno: "Подробни резултати: ",
    interes: "Тип лихва",
    zuti: "Ориентиран към детайлите - систематичен, предвидим",
    interests: {
      RED: {
        description:
          "Решаване на проблеми - практически, технически, практически",
        title: "ЧЕРВЕН Интерес",
      },
      BLUE: {
        description: "Творчески/Хуманитарен - креативен, замислен, тих",
        title: "СИН Интерес",
      },
      YELLOW: {
        description: "Ориентиран към детайлите - систематичен, предвидимe",
        title: "ЖЪЛТ Интерес",
      },
      GREEN: {
        description: "Инфлуенсър – убедителен, ориентиран към хората",
        title: "ЗЕЛЕН Интерес",
      },
    },
    saving: "Saving",
    tryAgain: "Try again",
    viewRankings: "Виж Класацията",
    rankingsTitle: "Топ Резултати",
    loading: "Зареждане...",
    error: "Грешка при зареждане",
    noScoresError: "Не са изчислени резултати. Моля, опитайте отново.",
    userInfoMissing: "Липсва информация за потребителя",
    saveError: "Неуспешно запазване на резултатите. Моля, опитайте отново.",
    saveStage: "Запази напредъка",
    stageSaved: "Напредъкът е запазен!",
    continueQuiz: "Продължи теста",
    savedProgress: "Имате запазен напредък",
    savedProgressSection: "Раздел",
    savedProgressQuestion: "Въпрос",
    deleteSavedProgress: "Изтрий запазения напредък",
    // Add more translations as needed
  },
};
